import { useMemo, useState } from "react";
import { Select } from "antd";
import debounce from "lodash/debounce";
import { AiOutlineSearch } from "react-icons/ai";
import { useGET } from "@API2";

const { Option } = Select;

const MIN_SEARCH_LENGTH = 3;
const SEARCH_LIMIT = 20;

const HJSearchSelect = ({
  url,
  getQuery,
  placeholder,
  emptyText = "Sonuç bulunamadı.",
  disabled,
  onSelect,
  renderOption,
}) => {
  const [searchText, setSearchText] = useState("");

  const query =
    searchText.length >= MIN_SEARCH_LENGTH
      ? getQuery
        ? getQuery(searchText)
        : `?page=1&limit=${SEARCH_LIMIT}&search=${encodeURIComponent(
            searchText
          )}`
      : false;

  const { data, loading, error } = useGET(url, query);

  const handleSearch = useMemo(
    () => debounce((value) => setSearchText(value?.trim() || ""), 500),
    []
  );

  const rows = data?.rows || [];

  const getNotFoundContent = () => {
    if (searchText.length < MIN_SEARCH_LENGTH) {
      return `Aramak için en az ${MIN_SEARCH_LENGTH} karakter giriniz.`;
    }
    if (loading) {
      return "Aranıyor...";
    }
    if (error) {
      return "Liste alınamadı.";
    }
    return emptyText;
  };

  const handleSelect = (value) => {
    const record = rows.find(
      (row) => String(row?.id || row?._id) === String(value)
    );

    if (!record) {
      return;
    }

    onSelect?.(record);
  };

  return (
    <Select
      value={null}
      disabled={disabled}
      style={{ width: "100%" }}
      showSearch
      filterOption={false}
      loading={loading}
      placeholder={placeholder}
      suffixIcon={<AiOutlineSearch />}
      notFoundContent={getNotFoundContent()}
      onSearch={handleSearch}
      onSelect={handleSelect}
    >
      {rows.map((row) => {
        const id = String(row?.id || row?._id);

        return (
          <Option key={id} value={id}>
            {renderOption ? renderOption(row) : id}
          </Option>
        );
      })}
    </Select>
  );
};

export default HJSearchSelect;
